import { Box, Typography } from '@mui/material'
import { useState, useEffect } from 'react'


const Images = [
    {
        companyName: 'Native Supply Co.',
        imageUrl: 'https://hgasupply.com/cdn/shop/files/hga-not-today-satan-blue-denim-jacket-104856.jpg',
        title: 'Not today satan blue denim jacket',
    },
    {
        companyName: 'Elevated Faith',
        imageUrl: 'https://cdn.shopify.com/s/files/1/0956/3508/files/Jireh-Unisex-Hoodie_01.jpg',
        title: 'Jireh Unisex Hoodie',
    },
    {
        companyName: 'Kidan Clothing',
        imageUrl: 'https://kidanclothing.com/cdn/shop/files/imgonline-com-ua-convertRDfaQNClogeU_1080x.jpg',
        title: 'He Will Wipe Every Tear From Your Eyes',
    },
    {
        companyName: 'Nhim Apparel',
        imageUrl: 'https://cdn.shopify.com/s/files/1/1987/6203/files/IVY8415.jpg',
        title: 'WALKING WITH JESUS HOODIE IN OFF WHITE',
    },
]

export default function MiddlePiece() {
    const [currentImageIndex, setCurrentImageIndex] = useState(0)
    const [fade, setFade] = useState(true)

    useEffect(() => {
        const interval = setInterval(() => {
            setFade(false) 
            setTimeout(() => {
                setCurrentImageIndex((prevIndex) => (prevIndex + 1) % Images.length)
                setFade(true)
            }, 500) 
            
        }, 3000) // Change image every 3 seconds

        return () => clearInterval(interval) // Cleanup interval on component unmount
    }, [])
    return (
        <Box

            sx={{
                mx: 1.5,
                my: 3,
                position: 'relative',
                height: 300,
                width: '94%',
                borderRadius: 7,
                overflow: 'hidden',
                backgroundImage: `url(${Images[currentImageIndex].imageUrl})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                cursor: 'pointer',
                transition: 'opacity 0.5s ease-in-out', 
                opacity: fade ? 1 : 0.5, 
                textAlign: 'left',
            }}
        >

            <Box
                sx={{
                    position: 'absolute',
                    inset: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.2)', // Semi-transparent overlay
                }}
            />

            {/* "Ends Sunday" at the top */}
            <Box
                sx={{
                    position: 'absolute',
                    top: 20, // Moves it to the top
                    left: 20, // Aligns it to the left
                    color: 'white',
                }}
            >
                <Typography variant="caption" sx={{ 
                    p: 0.8,
                    borderRadius: 5,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    fontSize: '0.75rem', fontWeight: 'bold' }}>
                    ★ Fan Favorites
                </Typography>
            </Box>
            <Box
                sx={{
                    position: 'absolute',
                    bottom: 16,
                    left: 16,
                    color: 'white',
                }}
            >

                <Typography variant="h6" sx={{ fontWeight: 'bold', mt: 0.5 }}>
                    {Images[currentImageIndex].companyName}
                </Typography>
                <Typography variant="body2" sx={{ mt: 0.5 }}>
                    {Images[currentImageIndex].title}
                </Typography>
            </Box>


        </Box>
    )

}
